import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { obtenerMatrizPromociones, obtenerArchivos } from "../AccionesBackend";
import { Col, Container, Row, Modal, Button } from "react-bootstrap";
import {BotonRegresar} from "../BotonRegresar";

const ALLOWED_BRANDS = ["Izzi", "Sky", "Izzi móvil", "Wizz"];

export const MatrizPromociones = () => {
    const { marca } = useParams(); // Asegúrate de que la ruta use :marca
    const [promociones, setPromociones] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [filteredPromos, setFilteredPromos] = useState([]);
    const [promoSeleccionada, setPromoSeleccionada] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // 1. Obtener todas las promociones según la marca (parámetro de la URL)
    useEffect(() => {
        console.log("Parámetro de URL marca:", marca);
        const fetchPromociones = async () => {
            try {
                const result = await obtenerMatrizPromociones(marca);
                console.log("Promociones recibidas:", result.matrizPromociones);
                if (result.success && result.matrizPromociones) {
                    // Filtramos solo las promociones de las marcas permitidas
                    const promos = result.matrizPromociones.filter((p) =>
                        ALLOWED_BRANDS.includes(p.marca)
                    );
                    console.log("Promociones filtradas:", promos);
                    setPromociones(promos);
                    if (promos.length > 0) {
                        // Si no hay un selectedBrand establecido, usamos el parámetro de la URL (si es válido)
                        const marcaParam = marca && ALLOWED_BRANDS.includes(marca)
                            ? marca
                            : promos[0].marca;
                        setSelectedBrand(marcaParam);
                    }
                } else {
                    setError("No hay promociones para esta sección.");
                }
            } catch (err) {
                console.error("Error al obtener las promociones:", err);
                setError("Error al obtener las promociones.");
            } finally {
                setLoading(false);
            }
        };

        fetchPromociones();
    }, [marca]);

    // 2. Actualizar las promociones filtradas según la marca seleccionada
    useEffect(() => {
        if (selectedBrand && promociones.length > 0) {
            const filtered = promociones.filter(
                (p) => p.marca.toLowerCase() === selectedBrand.toLowerCase()
            );
            console.log("Promociones filtradas por selectedBrand:", filtered);
            setFilteredPromos(filtered);
            if (filtered.length > 0) {
                setPromoSeleccionada(filtered[0]);
            } else {
                setPromoSeleccionada(null);
            }
        }
    }, [selectedBrand, promociones]);

    // 3. Obtener el archivo asociado a la promoción seleccionada
    useEffect(() => {
        const fetchAssets = async () => {
            if (!promoSeleccionada) {
                setPdfUrl(null);
                return;
            }

            // 1) Archivo principal
            if (promoSeleccionada.pdfPromocion_id) {
                try {
                    const result = await obtenerArchivos({
                        archivoId: promoSeleccionada.pdfPromocion_id,
                    });
                    if (result.success && result.archivos.length > 0) {
                        setPdfUrl(result.archivos[0].ruta_archivo);
                    } else {
                        setPdfUrl(null);
                    }
                } catch (err) {
                    console.error("Error al obtener el archivo:", err);
                    setPdfUrl(null);
                }
            } else {
                setPdfUrl(null);
            }
        };

        fetchAssets();
    }, [promoSeleccionada]);
    ;

    // Funciones para controlar el modal
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    if (loading) {
        return <p>Cargando promociones...</p>;
    }

    if (error) {
        return <h2>{error}</h2>;
    }

    // Visualizador de promociones al estilo flyers
    const VisualizadorPromociones = () => {
        return (
            <Row className="justify-content-center">
                {filteredPromos.map((promo) => {
                    const hasPortada = !!promo.ruta_portada;
                    const isPdf = !hasPortada && promo.ruta_archivo && promo.ruta_archivo.toLowerCase().endsWith(".pdf");
                    const isImage = !hasPortada && promo.ruta_archivo && (
                        promo.ruta_archivo.toLowerCase().endsWith(".jpg") || 
                        promo.ruta_archivo.toLowerCase().endsWith(".jpeg") || 
                        promo.ruta_archivo.toLowerCase().endsWith(".png") || 
                        promo.ruta_archivo.toLowerCase().endsWith(".webp")
                    );

                    return (
                        <Col key={promo.id || promo.marca} xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <div
                                className="flyer-card"
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    padding: "10px",
                                    textAlign: "center",
                                    background: "#fff",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div style={{ height: "200px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", borderRadius: "4px", marginBottom: "10px", background: "#f8f9fa" }}>
                                    {hasPortada ? (
                                        <img
                                            src={promo.ruta_portada}
                                            alt={promo.nombre_oferta}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : isImage ? (
                                        <img
                                            src={promo.ruta_archivo}
                                            alt={promo.nombre_oferta}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : isPdf ? (
                                        <div className="file-icon" style={{ fontSize: "50px" }}> 📄 <br/><span style={{ fontSize: "12px" }}>PDF</span> </div>
                                    ) : (
                                        <div className="file-icon" style={{ fontSize: "50px" }}> 📑 <br/><span style={{ fontSize: "12px" }}>Sin documento</span></div>
                                    )}
                                </div>
                                <div>
                                    <h5 style={{ fontSize: "1rem", fontWeight: "bold" }}>{promo.nombre_oferta}</h5>
                                    <p style={{ fontSize: "0.8rem", color: "#666" }}>{promo.marca}</p>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => {
                                            setPromoSeleccionada(promo);
                                            handleShow();
                                        }}
                                    >
                                        Ver detalles
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        );
    };

    return (
        <section style={{ paddingTop: "120px" }}>
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar/>
                    <h1>Promociones de {selectedBrand}</h1>
                </div>

                <VisualizadorPromociones />
            </Container>

            {/* Modal con detalles */}
            <Modal
                show={showModal}
                onHide={handleClose}
                centered
                size="lg"
                style={{ paddingTop: "180px" }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Detalles de la Promoción</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row className="align-items-center">
                            <Col md={6}>
                                {pdfUrl ? (
                                    pdfUrl.toLowerCase().endsWith(".pdf") ? (
                                        <iframe
                                            src={pdfUrl}
                                            style={{
                                                width: "100%",
                                                height: "400px",
                                                borderRadius: "8px",
                                            }}
                                            title="PDF Promoción"
                                        />
                                    ) : (
                                        <img
                                            src={pdfUrl}
                                            alt="Vista previa"
                                            style={{
                                                width: "100%",
                                                maxHeight: "400px",
                                                objectFit: "contain",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    )
                                ) : (
                                    <p>No hay documento disponible.</p>
                                )}
                            </Col>
                            <Col md={6}>
                                {promoSeleccionada && (
                                    <>
                                        <h2 className="fw-bold">
                                            {promoSeleccionada.nombre_oferta}
                                        </h2>
                                        <p>
                                            <strong>🏷️ Marca:</strong>{" "}
                                            {promoSeleccionada.marca || "Sin marca"}
                                        </p>
                                        <p>
                                            <strong>🔢 No. AC:</strong>{" "}
                                            {promoSeleccionada.no_ac || "No especificado"}
                                        </p>
                                        <p>
                                            <strong>📅 Fecha inicial:</strong>{" "}
                                            {promoSeleccionada.fecha_inicial || "No disponible"}
                                        </p>
                                        <p>
                                            <strong>📅 Vigencia:</strong>{" "}
                                            {promoSeleccionada.vigencia || "No disponible"}
                                        </p>
                                        <p>
                                            <strong>📡 Canales que aplican:</strong>{" "}
                                            {promoSeleccionada.canales_aplica || "No especificado"}
                                        </p>
                                        <p>
                                            <strong>🌎 Cobertura:</strong>{" "}
                                            {promoSeleccionada.cobertura || "No especificado"}
                                        </p>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </section>
    );
};